import { render, staticRenderFns } from "./TransferRequestRowActions.vue?vue&type=template&id=64ca5ee4"
import script from "./TransferRequestRowActions.vue?vue&type=script&lang=js"
export * from "./TransferRequestRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports